export const zudokuNavigation = [
  {
    type: "category",
    label: "Documentation",
    items: [
      {
        type: "category",
        label: "Overview",
        icon: "book-open",
        items: ["/introduction", "/getting-started/quickstart"],
      },
      {
        type: "category",
        label: "Getting Started",
        icon: "compass",
        items: ["/authentication", "/getting-started/first-request", "/getting-started/using-api-reference"],
      },
    ],
  },
  {
    type: "link",
    to: "/api",
    label: "API Reference",
  },
  {
    type: "category",
    label: "Tables",
    items: [
      "/tables/response-code",
      "/tables/status",
      "/tables/top-up-amounts",
      "/tables/mt-status",
      "/tables/gsm-character-set",
    ],
  },
];
